import React from 'react';
import {
  Box,
  HStack,
  IconButton,
  Input,
  Button,
  Image,
} from '@chakra-ui/react';
import gallery_icon from '../Assets/icons/gallery_icon.svg';
import setting_icon from '../Assets/icons/setting_icon.svg';
import car_icon from '../Assets/icons/car_icon.svg';

const ChatInput = ({
  inputValue,
  setInputValue,
  isLoading,
  onSubmit,
  placeholder = 'What can i help you with?',
}) => {
  const handleSubmit = e => {
    e.preventDefault();
    if (inputValue.trim() && !isLoading) {
      onSubmit(inputValue);
    }
  };

  const handleKeyPress = e => {
    if (e.key === 'Enter' && !e.shiftKey && !isLoading) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <Box
      bg="#F8F8F8"
      border="none"
      borderRadius="2xl"
      p={4}
      _focus={{
        bg: 'white',
        boxShadow: '0 0 0 1px #3182CE',
      }}
      w="full"
      maxW="600px"
    >
      <form onSubmit={handleSubmit}>
        {/* First Row - Input Text */}
        <Input
          placeholder={placeholder}
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
          onKeyPress={handleKeyPress}
          bg="transparent"
          border="none"
          fontSize="lg"
          _placeholder={{ color: 'gray.400' }}
          _focus={{
            bg: 'transparent',
            boxShadow: 'none',
          }}
          px={0}
          py={0}
          mb={3}
        />

        {/* Second Row - Icons */}
        <HStack spacing={3} justify="space-between">
          <HStack spacing={2}>
            {/* <IconButton
              icon={<Image src={gallery_icon} alt="Gallery" w="4" h="4" />}
              variant="ghost"
              size="sm"
              color="gray.400"
              _hover={{ color: 'gray.600' }}
              aria-label="Image"
              minW="auto"
              h="auto"
              p={1}
            /> */}
            {/* <IconButton
              icon={<Image src={setting_icon} alt="Settings" w="4" h="4" />}
              variant="ghost"
              size="sm"
              color="gray.400"
              _hover={{ color: 'gray.600' }}
              aria-label="Settings"
              minW="auto"
              h="auto"
              p={1}
            /> */}
            {/* <IconButton
              icon={<Image src={car_icon} alt="Car" w="4" h="4" />}
              variant="ghost"
              size="sm"
              color="gray.400"
              _hover={{ color: 'gray.600' }}
              aria-label="Chat"
              minW="auto"
              h="auto"
              p={1}
            /> */}
          </HStack>
          {/* <Button
            type="submit"
            size="sm"
            bg="blue.500"
            color="white"
            _hover={{ bg: 'blue.600' }}
            isDisabled={!inputValue.trim() || isLoading}
          >
            Start Chat
          </Button> */}
          <Button
            type="submit"
            size="sm"
            bg="blue.500"
            color="white"
            _hover={{ bg: 'blue.600' }}
            isDisabled={!inputValue.trim()}
            isLoading={isLoading}
            loadingText="Loading..."
          >
            Start Chat
          </Button>
        </HStack>
      </form>
    </Box>
  );
};

export default ChatInput;
